import { render, staticRenderFns } from "./Clientcard.vue?vue&type=template&id=6429fbd0"
import script from "./Clientcard.vue?vue&type=script&lang=js"
export * from "./Clientcard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports